module.exports = __webpack_public_path__ + "static/media/taskit_logo_web.4cd17faa.png";